import { MongoAbility } from '@casl/ability';
import { UserRoleType } from 'components/ui/UserRole/user-role.enum';
import { useAuthenticatedUser } from 'features/auth/hooks/useAuthenticatedUser';
import getUserPermissions from 'features/auth/permissions';
import React, { PropsWithChildren, useContext } from 'react';

interface PermissionsContextValue {
  ability: MongoAbility;
  user: {
    id: string;
    name: string;
    email: string;
    role: UserRoleType;
    active: boolean;
    isVerified: boolean;
    createdAt: Date;
    updatedAt: Date;
  } | null;
}

const PermissionsContext = React.createContext<PermissionsContextValue | undefined>(
	undefined,
);

export const usePermissionsContext = () => {
  const value = useContext(PermissionsContext);
  if (value === undefined) {
		throw Error('usePermissionsContext can not be used outside a PermissionsProvider');
  }
  return value;
};

export default function PermissionsProvider({ children }: PropsWithChildren) {
  const { user } = useAuthenticatedUser();
  const ability = getUserPermissions(user);

  return (
    <PermissionsContext.Provider value={{ ability, user }}>
      {children}
    </PermissionsContext.Provider>
  );
}
